import { FC } from "react";

import type { IMultiAnalysisTimeRange, IStructureTreePoint } from "../../types";
import type { IMultiAnalysisTemplateCell } from "../../utils/analysis-template-settings";
import { ManualTemplateCellFiltersEditor } from "./manual-filters-editor";
import { MeasureListTemplateCellEditor } from "./measure-list-editor";

interface ITemplateCellEditorProps {
  cell: IMultiAnalysisTemplateCell;
  configureFiltersManually: boolean;
  points: readonly IStructureTreePoint[];
  range: IMultiAnalysisTimeRange;
  onChange: (patch: Partial<Pick<IMultiAnalysisTemplateCell, "measureType" | "filters">>) => void;
}

export const TemplateCellEditor: FC<ITemplateCellEditorProps> = ({
  cell,
  configureFiltersManually,
  points,
  range,
  onChange,
}) =>
  configureFiltersManually ? (
    <ManualTemplateCellFiltersEditor cell={cell} onChange={onChange} />
  ) : (
    <MeasureListTemplateCellEditor cell={cell} points={points} range={range} onChange={onChange} />
  );
